// MUIのコンポーネントをインポート
import { Box, Grid} from '@mui/material';
// サンプル画像をインポート
import sampleImg from "../../statics/img/cat240.png";

/** user 資料ページ メイン */
const UMDisplay = () => {
    return (
        // スクロール可能なコンテナを作成
        <Box overflow='scroll' sx={{height: '480px'}}>
            {/* 中央寄せのグリッドコンテナ */}
            <Grid container direction="column" alignItems="center">
                {/* サンプル画像の表示 */}
                <img 
                    src={sampleImg} 
                    height={400} 
                    width={400} 
                    alt=""
                />
            </Grid>
        </Box>
    );
}

export default UMDisplay;